import { gql } from "@apollo/client";export default gql`mutation AddWorksheetTagMap(
    $objects: [worksheet_worksheet_tag_map_insert_input!]!
) {
    addWorksheetTagMap: insert_worksheet_worksheet_tag_map(objects: $objects) {
        affected_rows
    }
}
`;
